import { render } from "./App.vue?vue&type=template&id=fbdce86e&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=fbdce86e&lang=scss&scoped=true"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbdce86e"]])

export default __exports__